"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2306],{

/***/ 90480:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/**
 * 全局接口 code 状态码定义
 */ const CODE = {
    /** 成功 */ OK: 0,
    /** 用户端-未登录 */ UNAUTHORIZED: [
        401
    ]
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CODE);


/***/ }),

/***/ 98442:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "aG": () => (/* binding */ UPDATE_PRICE),
/* harmony export */   "r0": () => (/* binding */ UPDATE_USER_INFO)
/* harmony export */ });
/* unused harmony export AI_PPT_SCROLL */
const UPDATE_USER_INFO = "UPDATE_USER_INFO";
const AI_PPT_SCROLL = "AI_PPT_SCROLL";
const UPDATE_PRICE = "UPDATE_PRICE";


/***/ }),

/***/ 62893:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D3": () => (/* binding */ useGetIsRequested),
/* harmony export */   "Jh": () => (/* binding */ useGetUserInfo),
/* harmony export */   "nr": () => (/* binding */ useGetMeidouInfo),
/* harmony export */   "rC": () => (/* binding */ useGetCutoutInfo)
/* harmony export */ });
/* unused harmony exports useSetUserInfo, useSetMeidouInfo */
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25344);

const useGetUserInfo = ()=>{
    return (0,_store__WEBPACK_IMPORTED_MODULE_0__/* .useStoreState */ .Kw)((state)=>state.userModel.userInfo);
};
const useSetUserInfo = ()=>{
    return useStoreActions((actions)=>actions.userModel.setUserInfo);
};
const useGetMeidouInfo = ()=>{
    return (0,_store__WEBPACK_IMPORTED_MODULE_0__/* .useStoreState */ .Kw)((state)=>state.userModel.meidouInfo);
};
const useSetMeidouInfo = ()=>{
    return useStoreActions((actions)=>actions.userModel.setMeidouInfo);
};
const useGetCutoutInfo = ()=>{
    return (0,_store__WEBPACK_IMPORTED_MODULE_0__/* .useStoreState */ .Kw)((state)=>state.userModel.cutoutInfo);
};
const useGetIsRequested = ()=>{
    return (0,_store__WEBPACK_IMPORTED_MODULE_0__/* .useStoreState */ .Kw)((state)=>state.userModel.isRequested);
};


/***/ }),

/***/ 59043:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ layout)
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/components/script/index.tsx


const ScriptCustomize = (props)=>{
    const { children , id =Math.random().toString(36).slice(2) , ...resetProps } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        id: id,
        ...resetProps,
        dangerouslySetInnerHTML: {
            __html: children ? "(".concat(children.toString(), ")();") : ""
        }
    });
};
/* harmony default export */ const components_script = (ScriptCustomize);

;// CONCATENATED MODULE: ./src/assets/images/favicon.ico
/* harmony default export */ const favicon = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/favicon.3e797464.ico","height":60,"width":60});
;// CONCATENATED MODULE: ./src/utils/hmt.ts
/* eslint-disable */ /**
 * 官网百度统计
 */ /* harmony default export */ const hmt = (()=>{
    var _hmt = _hmt || [];
    (function() {
        var ref;
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?948a3e71e024991ef78897ecf6377e4e";
        var s = document.getElementsByTagName("script")[0];
        (ref = s.parentNode) === null || ref === void 0 ? void 0 : ref.insertBefore(hm, s);
    })();
});

;// CONCATENATED MODULE: ./src/layout/head/index.tsx





const PublicHead = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "renderer",
                        content: "webkit"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        httpEquiv: "X-UA-Compatible",
                        content: "IE=edge,chrome=1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "referrer",
                        content: "no-referrer-when-downgrade"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/x-icon",
                        href: favicon.src
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.designkit.cn/ppt"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_script, {
                id: "init-hmt",
                children: hmt
            })
        ]
    });
};
/* harmony default export */ const layout_head = (PublicHead);

;// CONCATENATED MODULE: ./src/layout/index.tsx


const Layout = (props)=>{
    const { children  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_head, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                children: children
            })
        ]
    });
};
/* harmony default export */ const layout = (Layout);


/***/ }),

/***/ 26870:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
class EventBus {
    on(event, callback) {
        if (!this.events.has(event)) {
            this.events.set(event, new Set());
        }
        this.events.get(event).add(callback);
    }
    off(event, callback) {
        var ref;
        (ref = this.events.get(event)) === null || ref === void 0 ? void 0 : ref.delete(callback);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var ref;
        (ref = this.events.get(event)) === null || ref === void 0 ? void 0 : ref.forEach((cb)=>cb(...args));
    }
    once(event, callback) {
        var _this = this;
        const onceWrapper = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            callback(...args);
            _this.off(event, onceWrapper);
        };
        this.on(event, onceWrapper);
    }
    clear(event) {
        if (event) {
            this.events.delete(event);
        } else {
            this.events.clear();
        }
    }
    constructor(){
        this.events = new Map();
    }
}
const event = new EventBus();
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (event);


/***/ }),

/***/ 92114:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "RN": () => (/* binding */ getCallback),
  "bG": () => (/* binding */ getUserInfo),
  "hY": () => (/* binding */ handleLogout),
  "Br": () => (/* binding */ initAccount),
  "lU": () => (/* binding */ jumpToLogin),
  "C2": () => (/* binding */ openVipModal)
});

// UNUSED EXPORTS: updateLogoutAccessToken

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/query-string/index.js + 1 modules
var query_string = __webpack_require__(81167);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-identity/lib/index.js
var lib = __webpack_require__(10275);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/overseasAccessModal/jumpQuery.js
var overseasAccessModal_jumpQuery = __webpack_require__(30106);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/index.js
var teamInfo = __webpack_require__(46718);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/uidKit.js
var uidKit = __webpack_require__(83642);
// EXTERNAL MODULE: ./src/constants/code.ts
var code = __webpack_require__(90480);
// EXTERNAL MODULE: ./src/utils/request.ts
var utils_request = __webpack_require__(28565);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(1880);
;// CONCATENATED MODULE: ./src/services/user/index.ts
/* provided dependency */ var process = __webpack_require__(34155);


/**
 * 用户信息详情
 * @docs: https://api-mock.meitu-int.com/project/1594/interface/api/82889
 */ const fetchUserInfo = async function() {
    return await (0,utils_request/* default */.ZP)("".concat((0,constants/* getIntranetHost */.Cu)(), "/user/info"), {
        method: "GET",
        hideErrorToast: true
    });
};
const fetchUnReadMessage = async function(params) {
    return await request("".concat(process.env.REACT_APP_API_FEEDBACK, "/im_v2/unread_count.json"), {
        method: "GET",
        data: params
    });
};

// EXTERNAL MODULE: ./src/store/index.ts + 1 modules
var store = __webpack_require__(25344);
// EXTERNAL MODULE: ./src/utils/gid.ts
var utils_gid = __webpack_require__(83353);
// EXTERNAL MODULE: ./node_modules/@meitu/saas-subscription-popup/dist/esm/index.js + 4 modules
var esm = __webpack_require__(76926);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(45332);
;// CONCATENATED MODULE: ./src/utils/login.tsx
// import * as Sentry from "@sentry/react";













let processingLogin = ()=>{};
// HACK 退登问题
let accessToken = "";
let actionType;
let vipModalCloseCallback = undefined;
let vipModalPayCallback = undefined;
const updateLogoutAccessToken = (token)=>{
    accessToken = token;
};
const getEnvValue = (env)=>{
    // 1 test, 0 线上（默认）, 2 beta
    let value;
    switch(env){
        case "release":
            value = 0;
            break;
        case "beta":
            value = 2;
            break;
        default:
            value = 1;
    }
    return value;
};
const getCallback = ()=>{
    const url = "".concat(window.location.protocol, "//").concat(window.location.host, "/callback.html?refresh=0");
    return url;
};
/**
 * 初始化订阅弹窗组件
 */ const initVipModal = async (initVipModalOptions)=>{
    const params = query_string/* default.parse */.Z.parse(window.location.search);
    let env = "release";
    if (false) {}
    const first_url = decodeURIComponent(params.first_url || window.sessionStorage.getItem("first_url") || "");
    // 订阅团队id
    const localIdentity = (0,lib/* getLocalIdentity */.u5)();
    const jumpQuery = (0,overseasAccessModal_jumpQuery/* getJumpQuery */.H)();
    const instanceVipModal = new esm/* default */.ZP({
        env,
        theme: "light",
        commonParams: {
            entrance: constants/* SCENE */.vX,
            module_id: constants/* SCENE */.vX,
            source: constants/* SCENE */.vX,
            app_key: (0,constants/* getAppKey */.AJ)(),
            client_id: (0,constants/* getClientID */.kU)(),
            matrix_channel: (0,utils/* getMatrixChannel */.T5)(),
            callback_origin: window.location.origin,
            channel: (0,utils/* getChannel */.mr)(),
            first_ur: encodeURIComponent(first_url),
            subscribe_type: "meidou",
            ...jumpQuery,
            ...localIdentity ? {
                oid: (localIdentity === null || localIdentity === void 0 ? void 0 : localIdentity.oid) || 0,
                groupId: (localIdentity === null || localIdentity === void 0 ? void 0 : localIdentity.groupId) || 0,
                purchase_scene: "normal"
            } : {},
            ...initVipModalOptions
        }
    });
    instanceVipModal.on(esm/* EventNameEnum.SUCCESS */.Lx.SUCCESS, async ()=>{
        // 更新接口
        await getUserInfo();
        vipModalPayCallback === null || vipModalPayCallback === void 0 ? void 0 : vipModalPayCallback();
    }).on(esm/* EventNameEnum.LOGININVALID */.Lx.LOGININVALID, ()=>{
        // 登录态失效
        handleLogout();
    }).on(esm/* EventNameEnum.CLOSE */.Lx.CLOSE, ()=>{
        vipModalCloseCallback === null || vipModalCloseCallback === void 0 ? void 0 : vipModalCloseCallback();
    });
    window.instanceVipModal = instanceVipModal;
};
const initAccount = async ()=>{
    const gid = await (0,utils_gid/* waitUntilGetGid */.S)();
    const { MeituAccount  } = await Promise.all(/* import() */[__webpack_require__.e(4067), __webpack_require__.e(4640), __webpack_require__.e(4121), __webpack_require__.e(5112), __webpack_require__.e(9713), __webpack_require__.e(505), __webpack_require__.e(3999), __webpack_require__.e(3209)]).then(__webpack_require__.bind(__webpack_require__, 13209));
    window.account = MeituAccount({
        env: getEnvValue("release"),
        gid,
        clientId: (0,constants/* getClientID */.kU)(),
        theme: "mtxx",
        clientLanguage: "zh-Hans",
        overseas: 0,
        clientConfigs: {
            abroad: false,
            needPhone: false,
            enableWeChatOfficialAccount: true
        },
        syncDomains: true,
        onNeedLogin () {},
        onLogining () {},
        onLoginError () {},
        onLoginSuccess: async (result)=>{
            actionType = "login";
            window.localStorage.setItem("access_token", result.accessToken);
            ;
            const status = await (0,teamInfo/* openIdentitySwitchPopupAfterLogin */.lz)(result.uid, result.result);
            if (!status) return;
            // 登录成功
            processingLogin(result.accessToken);
            (0,uidKit/* setLocalUid */.Tc)(result.uid);
            getUserInfo();
            // 登录成功默认切换为个人身份
            (0,lib/* setLocalIdentity */.kF)(0, 0);
        },
        onLogoutError () {},
        onLogoutSuccess () {
            actionType = "logout";
        },
        syncDomainsOptions: {
            onComplete () {
                if (actionType === "logout") {
                    window.location.reload();
                }
            }
        }
    });
};
const openAccount = async ()=>{
    //第三方帐号登录，退出后使用页面跳转涉及帐号内部状态同步，须确保帐号内部登录态清除
    await window.account.isLogin();
    const { openLoginPopup  } = await Promise.all(/* import() */[__webpack_require__.e(4067), __webpack_require__.e(4644), __webpack_require__.e(4640), __webpack_require__.e(4121), __webpack_require__.e(5112), __webpack_require__.e(7722), __webpack_require__.e(9713), __webpack_require__.e(3999), __webpack_require__.e(2071)]).then(__webpack_require__.bind(__webpack_require__, 42071));
    const { ThirdPartyPlatform  } = await Promise.all(/* import() */[__webpack_require__.e(4640), __webpack_require__.e(4121), __webpack_require__.e(5112)]).then(__webpack_require__.bind(__webpack_require__, 75112));
    const { setClientTheme  } = await Promise.all(/* import() */[__webpack_require__.e(4067), __webpack_require__.e(4640), __webpack_require__.e(4121), __webpack_require__.e(5112), __webpack_require__.e(9713)]).then(__webpack_require__.bind(__webpack_require__, 99713));
    openLoginPopup({
        // ...登录弹窗配置选项，详见：LoginPopupProps
        title (text) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    color: "var(--content-primary, #0f1729)",
                    textAlign: "center",
                    fontSize: "24px",
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "32px"
                },
                children: text
            });
        },
        autoDetectAndSetDarkTheme: false,
        theme: "v4",
        containerStyle: {
            minHeight: 473
        },
        useLoginMethod: "",
        showMeituXiuXiuQRCode: false,
        thirdPartyAccounts: [
            ThirdPartyPlatform.Meitu,
            ThirdPartyPlatform.Weibo,
            ThirdPartyPlatform.WeChat,
            ThirdPartyPlatform.QQ
        ],
        borderRadius: "14px",
        // 隐藏关闭按钮
        showCloseButton: true,
        closeable: true,
        switch: true,
        leftSide () {
            return '<div style="width: 300px; height: 100%; min-height: 509px; border-radius: 14px 0 0 14px; background-image: url(https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/login/login.svg); background-size: cover; background-position: center center;"></div>';
        },
        onClose () {
        // 关闭弹窗后的自定义处理，略...
        }
    });
};
// 未登录态时，打开登录弹窗
const jumpToLogin = async ()=>{
    if (!window.account) {
        await initAccount();
    }
    // 打开登录弹窗
    await openAccount();
    // 等待登录结果
    return await new Promise((resolve)=>processingLogin = resolve);
};
const handleLogout = async ()=>{
    var // 清楚埋点中的uid
    ref, ref1;
    (ref = window.mtstat) === null || ref === void 0 ? void 0 : ref.logout();
    // 清空用户信息和美豆信息
    store/* default.getActions */.ZP.getActions().userModel.setUserInfo(undefined);
    store/* default.getActions */.ZP.getActions().userModel.setMeidouInfo(null);
    // 清除团队信息
    (0,teamInfo/* clearTeamInfo */.bl)();
    // 移除身份切换监听
    (0,teamInfo/* disableIdentityChangeListener */.t2)();
    const { STORAGE_KEY_LOGIN_BY_WEB  } = await Promise.all(/* import() */[__webpack_require__.e(4067), __webpack_require__.e(4640), __webpack_require__.e(4121), __webpack_require__.e(5112), __webpack_require__.e(9713), __webpack_require__.e(505), __webpack_require__.e(3999), __webpack_require__.e(3209)]).then(__webpack_require__.bind(__webpack_require__, 13209));
    window.sessionStorage.removeItem(STORAGE_KEY_LOGIN_BY_WEB);
    !window.account && await initAccount();
    // HACK 退登问题
    let options = {};
    if (accessToken) {
        options = {
            headers: {
                "Access-Token": accessToken
            }
        };
    }
    (ref1 = window.account) === null || ref1 === void 0 ? void 0 : ref1.logout({}, options);
};
// 打开VIP会员弹窗
const openVipModal = async function() {
    let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, closeCallback = arguments.length > 1 ? arguments[1] : void 0, payCallback = arguments.length > 2 ? arguments[2] : void 0, initVipModalOptions = arguments.length > 3 ? arguments[3] : void 0;
    var ref;
    vipModalCloseCallback = closeCallback;
    vipModalPayCallback = payCallback;
    if (!window.instanceVipModal) {
        await initVipModal(initVipModalOptions);
    }
    if (params === null || params === void 0 ? void 0 : params.oid) {
        // 如果场景透传了oid，则需要实时根据最新的oid去透传对应的app_key
        params.app_key = (0,constants/* getAppKey */.AJ)(params.oid);
    }
    (ref = window.instanceVipModal) === null || ref === void 0 ? void 0 : ref.open(params);
};
/**
 * 获取用户信息
 */ const getUserInfo = async ()=>{
    const res = await fetchUserInfo();
    const data = res.data.data;
    if (res.data.code === code/* default.OK */.Z.OK && data) {
        var ref;
        window.localStorage.setItem("access_token", data.access_token);
        (0,uidKit/* setLocalUid */.Tc)(data.userInfo.id);
        (ref = window.mtstat) === null || ref === void 0 ? void 0 : ref.login(String(data.userInfo.id));
        updateLogoutAccessToken(data.access_token);
        store/* default.getActions */.ZP.getActions().userModel.setUserInfo({
            id: data.userInfo.id,
            screen_name: data.userInfo.screen_name,
            avatar: data.userInfo.avatar,
            is_vip: data.vipInfo.is_vip,
            vip_level: data.vipInfo.vip_level,
            vip_end_time: data.vipInfo.vip_end_time,
            vip_days: data.vipInfo.vip_days,
            available_amount: data.coinInfo.available_amount
        });
        store/* default.getActions */.ZP.getActions().userModel.setMeidouInfo(data.coinInfo);
        store/* default.getActions */.ZP.getActions().userModel.setCutoutInfo(data.cutoutInfo);
        // 开启身份切换监听
        (0,teamInfo/* enableIdentityChangeListener */.sr)();
    } else {
        store/* default.getActions */.ZP.getActions().userModel.setUserInfo(undefined);
        store/* default.getActions */.ZP.getActions().userModel.setMeidouInfo(null);
        store/* default.getActions */.ZP.getActions().userModel.setCutoutInfo(null);
    }
    store/* default.getActions */.ZP.getActions().userModel.setIsRequested(true);
};


/***/ }),

/***/ 28565:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": () => (/* binding */ request)
/* harmony export */ });
/* unused harmony exports getCommonParams, genMtccHeader */
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5121);
/* harmony import */ var _meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10275);
/* harmony import */ var _constants_code__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90480);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1880);
/* harmony import */ var _query__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3269);
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82345);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25344);
/* harmony import */ var _gid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83353);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45332);
/* harmony import */ var _constants_workbench__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40313);
/* harmony import */ var _meitu_xdesign_widgets_dist_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16197);
/* harmony import */ var _meitu_xdesign_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14000);

// import qs from "qs";











// 接口公共参数
const getCommonParams = async ()=>{
    if (false) {}
    const gid = await (0,_gid__WEBPACK_IMPORTED_MODULE_5__/* .waitUntilGetGid */ .S)();
    return {
        client_id: (0,_constants__WEBPACK_IMPORTED_MODULE_2__/* .getClientID */ .kU)(),
        client_language: (0,_meitu_xdesign_widgets_dist_utils__WEBPACK_IMPORTED_MODULE_9__/* .getClientLanguage */ .XF)("cn"),
        country_code: (0,_meitu_xdesign_widgets_dist_utils__WEBPACK_IMPORTED_MODULE_9__/* .getCountryCode */ .so)(),
        gid,
        enter_source: await (0,___WEBPACK_IMPORTED_MODULE_6__/* .getSource */ .b5)(),
        preview_mode: _constants__WEBPACK_IMPORTED_MODULE_2__/* .PREVIEW_MODE */ .i4
    };
};
// 成本分摊埋点公共参数
const getMtccCommonParams = async ()=>{
    var ref, ref1;
    const isToB = (0,_sdk__WEBPACK_IMPORTED_MODULE_3__/* .checkIsInSdk */ .X)();
    const params = {
        gid: (await getCommonParams()).gid,
        app_id: window._appId || undefined,
        osType: await (0,___WEBPACK_IMPORTED_MODULE_6__/* .getOsType */ .fP)(),
        isToB,
        // 设计室web:2
        // 内嵌:6
        virtualId: await (0,___WEBPACK_IMPORTED_MODULE_6__/* .isPcPlatform */ .FZ)() ? "6" : "2",
        functionInfo: {
            name: _constants_workbench__WEBPACK_IMPORTED_MODULE_7__/* .MTCCDataScene */ .AI[_constants_workbench__WEBPACK_IMPORTED_MODULE_7__/* .Scene.AiPPT */ .xs.AiPPT]
        },
        positionInfo: {
            level1: _constants_workbench__WEBPACK_IMPORTED_MODULE_7__/* .MTCCDataScene */ .AI[_constants_workbench__WEBPACK_IMPORTED_MODULE_7__/* .Scene.AiPPT */ .xs.AiPPT]
        },
        uid: (ref = _store__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getState */ .ZP.getState().userModel.userInfo) === null || ref === void 0 ? void 0 : ref.id,
        isPcPlatform: await (0,___WEBPACK_IMPORTED_MODULE_6__/* .isPcPlatform */ .FZ)(),
        isTeam: !!((ref1 = (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__/* .getLocalIdentity */ .u5)()) === null || ref1 === void 0 ? void 0 : ref1.oid),
        preview_mode: _constants__WEBPACK_IMPORTED_MODULE_2__/* .PREVIEW_MODE */ .i4
    };
    return params;
};
// 成本分摊埋点 header
const genMtccHeader = async (config)=>{
    var ref;
    if (!config) {
        // 无配置则默认为抠图
        config = {
            key: "plugin-matting"
        };
    }
    const MatchMTCC = Object.keys(_constants_workbench__WEBPACK_IMPORTED_MODULE_7__/* .MTCCData */ .gA).find((key)=>{
        var ref;
        return config.key === key || ((ref = config.url) === null || ref === void 0 ? void 0 : ref.indexOf(key)) >= 0;
    });
    const isToB = ((ref = config.headers) === null || ref === void 0 ? void 0 : ref["Enterprise-Access-Key"]) ? true : (0,_sdk__WEBPACK_IMPORTED_MODULE_3__/* .checkIsInSdk */ .X)();
    if (MatchMTCC) {
        var ref1;
        // 根据 url 匹配到的 MTCCData 的 key，获取对应的 position
        const findKey = _constants_workbench__WEBPACK_IMPORTED_MODULE_7__/* .MTCCData */ .gA[MatchMTCC].positionKey;
        const positionKey = findKey && config.data[findKey];
        const specialPosition = positionKey && ((ref1 = _constants_workbench__WEBPACK_IMPORTED_MODULE_7__/* .MTCCData */ .gA[MatchMTCC].position) === null || ref1 === void 0 ? void 0 : ref1[positionKey]) || "";
        const defaultMtccParams = await getMtccCommonParams();
        const params = {
            ...defaultMtccParams,
            isToB,
            mediaType: "",
            resMediaType: "",
            functionInfo: {
                ...defaultMtccParams.functionInfo,
                name: defaultMtccParams.functionInfo.name || _constants_workbench__WEBPACK_IMPORTED_MODULE_7__/* .MTCCData */ .gA[MatchMTCC].function || ""
            },
            positionInfo: {
                ...defaultMtccParams.positionInfo,
                level1: specialPosition || _constants_workbench__WEBPACK_IMPORTED_MODULE_7__/* .MTCCData */ .gA[MatchMTCC].position.default || _constants_workbench__WEBPACK_IMPORTED_MODULE_7__/* .MTCCData */ .gA[MatchMTCC].position[_constants_workbench__WEBPACK_IMPORTED_MODULE_7__/* .Scene.AiPPT */ .xs.AiPPT] || ""
            }
        };
        ;
        const headerString = await (0,_meitu_xdesign_utils__WEBPACK_IMPORTED_MODULE_8__/* .getMTCCClient */ .K5)(params);
        return headerString;
    }
};
// 全局的 axios 默认值
// ATTENTION: 这里的默认值会导致 x-design-widgets NavVipEntrance 组件请求接口错误
// axios.defaults.baseURL = "";
axios__WEBPACK_IMPORTED_MODULE_10__/* ["default"].defaults.withCredentials */ .Z.defaults.withCredentials = true;
axios__WEBPACK_IMPORTED_MODULE_10__/* ["default"].defaults.headers.post["Content-Type"] */ .Z.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
// 接口公共参数
// export const serverCommonParams = {
//   client_id: getClientID(),
//   preview_mode: PREVIEW_MODE,
// } as Record<string, string | number>;
// 添加请求拦截器
axios__WEBPACK_IMPORTED_MODULE_10__/* ["default"].interceptors.request.use */ .Z.interceptors.request.use(async (config)=>{
    const commonParams = await getCommonParams();
    if (config.method === "post") {
        const data = Object.assign({}, commonParams, config.data || {});
        try {
            const headers = await genMtccHeader(config);
            if (headers) {
                config.headers["x-mtcc-client"] = headers;
            }
        } catch (error) {
            ;
        }
        if (config.headers["Content-Type"] === "application/x-www-form-urlencoded") {
        // config.data = qs.stringify(data);
        } else {
            config.data = data;
        }
        config.params = {
            ...commonParams,
            ...config.params
        };
    } else if (config.method === "get") {
        config.params = Object.assign({
            timestamp: new Date().getTime()
        }, commonParams, config.params || {});
    }
    return config;
}, (error)=>{
    // 对请求错误做些什么
    return Promise.reject(error);
});
// 添加响应拦截器
axios__WEBPACK_IMPORTED_MODULE_10__/* ["default"].interceptors.response.use */ .Z.interceptors.response.use(async (response)=>{
    var ref;
    if (![
        "get",
        "post"
    ].includes(((ref = response.config) === null || ref === void 0 ? void 0 : ref.method) || "")) return response;
    // const config: RequestConfig = response.config;
    // const hideErrorToast = config.hideErrorToast;
    // console.log('hideErrorToast: ', hideErrorToast);
    // 只针对get/post请求方式的返回做处理
    const code = response.data.error_code;
    // const msg = response.data.msg;
    // console.log('msg: ', msg);
    if (code !== _constants_code__WEBPACK_IMPORTED_MODULE_1__/* ["default"].OK */ .Z.OK) {
    // if (!hideErrorToast) message.error(msg || '请求出错，请稍后再试');
    }
    // 对响应数据做点什么
    return response;
}, (error)=>{
    var ref, ref1;
    // message.error('您的网络发生异常，无法连接服务器');
    // return Promise.reject("您的网络发生异常，无法连接服务器");
    const res = error.response;
    const msg = (res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.message) || (res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.msg) || "请求出错，请稍后再试";
    ;
    return Promise.reject({
        msg,
        network: true,
        data: (res === null || res === void 0 ? void 0 : res.data) || {}
    });
});
function request(api, config) {
    const requestOptions = Object.assign({
        hideErrorToast: false
    }, {
        url: api
    }, config);
    if (!requestOptions.headers) {
        requestOptions.headers = {};
    }
    // 团队版请求头标识
    requestOptions.headers = Object.assign(requestOptions.headers, (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__/* .getRequestIdentityHeader */ .AW)());
    let token = "";
    if (true) {
        const query = (0,_query__WEBPACK_IMPORTED_MODULE_11__/* .getQuery */ .pm)();
        token = query.accessToken || window.localStorage.getItem("access_token") || "";
    }
    requestOptions.headers.access_token = token;
    return (0,axios__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(requestOptions);
}


/***/ })

}]);